import { OnboardingFormFields } from '@Types/index';
import { t } from 'i18next';
import { z } from 'zod';

export const ownersCenterScheme = z
  .object({
    [OnboardingFormFields.OWNER_CENTER_OWNER_LIST]: z.array(
      z.object({
        externalId: z.string(),
      })
    ),
    [OnboardingFormFields.OWNER_PERCENTAGE]: z
      .number({
        required_error: t('enErrors:ownerCenter.ownershipPercentageRequired'),
        invalid_type_error: t('enErrors:ownerCenter.ownershipPercentageRequired'),
      })
      .max(100)
      .min(0),
    [OnboardingFormFields.OWNER_CENTER_MULTI_OWNER_CONSENT]: z.boolean().optional(),
    [OnboardingFormFields.OWNER_CENTER_CONSENT_ONLY_UBO]: z.boolean().optional(),
  })
  .refine(
    (data) =>
      data[OnboardingFormFields.OWNER_CENTER_CONSENT_ONLY_UBO] ||
      data[OnboardingFormFields.OWNER_CENTER_MULTI_OWNER_CONSENT]
  )
  .refine(
    (data) =>
      !(
        data[OnboardingFormFields.OWNER_CENTER_CONSENT_ONLY_UBO] &&
        data[OnboardingFormFields.OWNER_PERCENTAGE] < 25
      ),
    {
      message: t('enErrors:ownerCenter.onlyUbo'),
      path: [OnboardingFormFields.OWNER_PERCENTAGE],
    }
  );
